import { observer } from "mobx-react";
import * as React from "react";
import { Link, useLocation } from "react-router";
import styled from "styled-components";

import { NAVIGATION_MENU, isLocationAvailable } from "@client/utils/Constants";
import Style from "@client/utils/Style";

import backgroundImage from "./images/background.png";
import cbslImage from "./images/cbsl-logo.svg";
import coriolisImage from "./images/coriolis-logo.svg";
import { TokenInfo } from "@typings/Identity";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: url("${backgroundImage}") center bottom no-repeat;
  background-size: cover;
`;
const CoriolisLogo = styled(Link)`
  width: 260px;
  height: 48px;
  background: url("${coriolisImage}") center no-repeat;
  margin: 0 auto;
  margin-top: 40px;
`;
const MenuItems = styled.div`
  display: flex;
  margin-top: 48px;
  margin-left: 96px;
  flex-direction: column;
  width: 160px;
`;
const MenuItem = styled(Link)`
  text-decoration: white;
  color: ${(props: any) =>
    props["data-highlight"] ? Style.palette.primaryHighlight : "white"};
  font-size: 18px;
  margin-top: 26px;
  &:first-child {
    margin-top: 0;
  }
`;
const CbslLogo = styled.a`
  width: 128px;
  height: 38px;
  background: url("${cbslImage}") center no-repeat;
  margin: 0 auto 64px auto;
`;
const Top = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

type Props = {
  tokenInfo: TokenInfo | null;
};

const ListPageNavigation: React.FC<Props> = observer(({ tokenInfo }) => {
  const location = useLocation();

  return (
    <Wrapper>
      <Top>
        <CoriolisLogo to="/" />
        <MenuItems>
          {NAVIGATION_MENU.map((menuItem, i) =>
            isLocationAvailable(menuItem.location, tokenInfo) ? (
              <MenuItem
                key={menuItem.location}
                to={menuItem.location}
                data-highlight={
                  location.pathname === menuItem.location ||
                  (i === 0 && location.pathname === "/")
                }
              >
                {menuItem.label}
              </MenuItem>
            ) : null,
          )}
        </MenuItems>
      </Top>
      <CbslLogo href="https://cloudbase.it" target="_blank" />
    </Wrapper>
  );
});

export default ListPageNavigation;
